import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { companyInfo } from '../mockData';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const features = [
    'Pharmaceutical Leaflet Specialists',
    'State-of-the-Art Printing Technology',
    'Quick Turnaround Time',
    'Regulatory Compliance Focused'
  ];

  return (
    <section id="home" className="relative bg-slate-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #1e40af 0, #1e40af 1px, transparent 0, transparent 50%)',
          backgroundSize: '20px 20px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 py-20 lg:py-28 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold">
                Trusted Since 1991
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Pharmaceutical
              <span className="block text-blue-600 mt-2">Leaflet Specialists</span>
            </h1>
            
            <p className="text-lg text-slate-600 leading-relaxed">
              With over 35 years of expertise and a focused specialization since 2006, we deliver precision-printed 
              pharmaceutical leaflets that ensure clarity, compliance, and patient safety.
            </p>

            {/* Features List */}
            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-blue-600 flex-shrink-0 mt-1" size={20} />
                  <span className="text-slate-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-4">
              <button
                onClick={() => scrollToSection('enquiry')}
                className="group px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center gap-2"
              >
                Get in Touch
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="px-8 py-4 border-2 border-slate-800 text-slate-800 font-semibold rounded-lg hover:bg-slate-800 hover:text-white transition-all duration-300"
              >
                Learn More
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-slate-200">
              <div>
                <div className="text-3xl font-bold text-blue-600">35+</div>
                <div className="text-sm text-slate-600 mt-1">Years</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600">2400M+</div>
                <div className="text-sm text-slate-600 mt-1">Leaflets</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600">6000+</div>
                <div className="text-sm text-slate-600 mt-1">Product Portfolio</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/d30xr233_image.png"
                alt="Quality Assurance and Compliance"
                className="w-full h-auto"
              />
              {/* Overlay Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-slate-900">99.8%</div>
                    <div className="text-sm text-slate-600">Quality Assurance Rate</div>
                  </div>
                  <div className="h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center">
                    <CheckCircle className="text-blue-600" size={32} />
                  </div>
                </div>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-blue-200 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-slate-800 rounded-full opacity-10 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
